import { Element } from '../../../../../common/html/element'
import classes from './classes.module.scss'

const CustomLegend = ({ backgroundColor }) => {
  return (
    <Element className={classes.customLegend} style={{ backgroundColor }} />
  )
}

export default CustomLegend
